import React, { useState } from "react";
import LaddaButton from "../../../components/buttons/laddaButton";
import { icons } from "../../../constants";
import { treatmentAction } from "../../../constants/selectData";
import { useForm } from "react-hook-form";
import { CustomTabPanel } from "../../../components/tabComponent";
import TreatmenDetailModal from "./treatmentDetailsModal";
import EditValuationModal from "./EditValuationModal";
import { formatMonthYear } from "../../../utils/dateUtils";
import { StyledTooltip } from "../../../components/toolltipComponent";
import ModalComponentRiskHelp from "../../createRisk/modalRiskHelp";
import { riskHelpIds } from "../../createRisk/riskHelpData";
import { isRiskVersion } from "../../../utils/riskAndOportunityVersion";
import "../styles.css";

const TreatmentDetailsTab = ({
  data,
  getRisk,
  isEditionAvailable,
  updateRiskupdateDate
}) => {
  const [treatmentDetailModal, setTreatmentDetailModal] = useState(false);
  const [valuationModalOpen, setValuationModalOpen] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [helpId, setHelpId] = useState(null);

  const handleClose = () => {
    setTreatmentDetailModal(false);
  };

  const handleCloseValuationModal = () => setValuationModalOpen(false);

  const { setValue } = useForm({
    defaultValues: {}
  });

  const getRiskLevel = (levelItem, hasVulnerability) => {
    const level = parseInt(levelItem, 10);
    if (hasVulnerability && level === 4) {
      return {
        class: "superior-level",
        textClass: "superior-level-text",
        text: "Nivel Superior"
      };
    }
    if (level === 4 && !hasVulnerability) {
      return {
        class: "high-level",
        textClass: "high-level-text",
        text: "Nivel Alto"
      };
    }
    switch (level) {
      case 1:
        return {
          class: "low-level",
          textClass: "low-level-text",
          text: "Nivel Bajo"
        };
      case 2:
        return {
          class: "medium-level",
          textClass: "medium-level-text",
          text: "Medio"
        };
      case 3:
        return {
          class: "high-level",
          textClass: "high-level-text",
          text: "Nivel Alto"
        };
      default:
        return {
          class: "default-level",
          textClass: "default-level-text",
          text: "Sin Nivel"
        };
    }
  };

  const getProbability = (residualRiskLevel) => {
    switch (residualRiskLevel) {
      case 1:
        return "Raro";
      case 2:
        return "Improbable";
      case 3:
        return "Posible";
      case 4:
        return "Probable";
      case 5:
        return "Casi seguro";
      default:
        return "";
    }
  };

  const getImpact = (residualRiskLevel) => {
    switch (residualRiskLevel) {
      case 1:
        return "Insignificante";
      case 2:
        return "Menor";
      case 3:
        return "Moderado";
      case 4:
        return "Mayor";
      case 5:
        return "Enorme";
      default:
        return "";
    }
  };

  const getVulnerability = (value) => {
    switch (parseInt(value, 10)) {
      case 1:
        return "Baja";
      case 3:
        return "Media";
      case 5:
        return "Alta";
      default:
        return "";
    }
  };

  const useVersion2 = isRiskVersion(data?.year, data?.month) === 2;

  const RiskLevelComponent = (levelItem) => {
    const {
      class: levelClass,
      textClass,
      text
    } = getRiskLevel(levelItem.levelItem, useVersion2);

    return (
      <StyledTooltip
        title={
          <>
            <div className="HContainer">
              <p className="toolkit-title">Probabilidad:</p>
              <p className="toolkit-content">
                {getProbability(data?.probability)}
              </p>
            </div>
            <div className="HContainer">
              <p className="toolkit-title">Impacto:</p>
              <p className="toolkit-content">{getImpact(data?.impact)}</p>
            </div>
            {useVersion2 && (
              <div className="HContainer">
                {/* v2 usa vulnerabilidad; en v1 no se muestra */}
                <p className="toolkit-title">Vulnerabilidad:</p>
                <p className="toolkit-content">{getVulnerability(data?.vulnerability) || "—"}</p>
              </div>
            )}
          </>
        }
        followCursor
      >
        <div className={`level ${levelClass}`}>
          <p className={textClass}>{text}</p>
        </div>
      </StyledTooltip>
    );
  };

  const openTreatmentDetailModal = () => {
    setTreatmentDetailModal(true);
    setValue("treatmentAction", data?.treatmentAction);
    setValue("activityStartDate", data?.activityStartDate);
    setValue("actionState", data?.actionState);
    setValue("responsible", data?.responsible);
  };

  return (
    <div>
      <CustomTabPanel value="1">
        <div className="header-titles">
          <div className="header-titles-item">
            <h2 className="gm-title" style={{ marginRight: "15px" }}>
              Fecha de Identificación:
            </h2>
            <p className="content-text">
              {data?.creationDate ? formatMonthYear(data?.creationDate) : ""}
            </p>
          </div>
          <div className="header-titles-item"></div>
          <div className="header-titles-item IHContainer align-center">
            <h2 className="gm-title" style={{ marginRight: "15px" }}>
              Valoración Global:
            </h2>
            <div className="IHContainer align-center" style={{ gap: "12px", flexWrap: "wrap" }}>
              <RiskLevelComponent levelItem={data?.riskLevel} />
          
             
                {isEditionAvailable && (
                  <button
                    type="button"
                    className="edit-valuation-btn-circle"
                    onClick={() => setValuationModalOpen(true)}
                    title="Editar valoración"
                    aria-label="Editar valoración"
                  >
                    <img className="btn-icon" src={icons.editBlack} alt="Editar" />
                  </button>
                )}
           
          
            </div>
          </div>
        </div>

        <div className="IHContainer align-center">
          <h2 className="gm-title">Acción de Tratamiento:</h2>
          <div
            className="pointer align-center j-center ml-5"
            onClick={() => {
              setHelpId(riskHelpIds.RISKTYPE);
              setOpenModal(true);
            }}
          >
            <img
              className="btn-add-icon"
              src={icons.infoExclamation}
              alt="icon"
              style={{ margin: "0 0 7px 0", width: "30px" }}
            />
          </div>
        </div>
        <p className="content-text">
          {data?.treatmentAction
            ? treatmentAction.find(
                (item) => item.value === data?.treatmentAction
              ).name
            : ""}
        </p>
        <div className="header-titles-item">
          <h2 className="gm-title">Fecha de Inicio de Actividades:</h2>
          <p className="content-text">
            {data?.activityStartDate
              ? formatMonthYear(data?.activityStartDate)
              : ""}
          </p>
        </div>
        <h2 className="gm-title">Responsable:</h2>
        <p className="content-text">{data?.responsible}</p>

        <div className="IHContainer align-center">
          <div style={{ margin: 0 }} className="tab-pill">
            Estado de la Acción:
          </div>
          <p style={{ marginLeft: "20px" }}>
            {data?.actionState == 1
              ? "Abierta"
              : data?.actionState == 2
              ? "Cerrada"
              : ""}
          </p>
        </div>

        <div className="j-center mt-20">
          {isEditionAvailable && (
            <LaddaButton
              variant="contained"
              onClick={() => {
                openTreatmentDetailModal();
              }}
            >
              <div className="IHContainer align-rigth">
                <img
                  className="btn-icon"
                  src={icons.editWhite}
                  alt="icon"
                  style={{ marginRight: "10px" }}
                />
                <p className="button_text">Editar</p>
              </div>
            </LaddaButton>
          )}
        </div>
      </CustomTabPanel>
      <TreatmenDetailModal
        open={treatmentDetailModal}
        handleClose={handleClose}
        data={data}
        getRisk={getRisk}
        updateRiskupdateDate={updateRiskupdateDate}
      />
      <EditValuationModal
        open={valuationModalOpen}
        handleClose={handleCloseValuationModal}
        data={data}
        getRisk={getRisk}
        useVersion2={useVersion2}
        updateRiskupdateDate={updateRiskupdateDate}
      />
      <ModalComponentRiskHelp
        openModal={openModal}
        handleClose={() => setOpenModal(false)}
        helpId={helpId}
      />
    </div>
  );
};

export default TreatmentDetailsTab;
